// Repeating list items (M26, D47): ticking one moves it to its next date.
/** Today's date in this runtime's time zone, as "YYYY-MM-DD". */
export function isoToday(now = new Date()) {
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60_000);
    return local.toISOString().slice(0, 10);
}
function addPeriod(date, repeat) {
    const [year, month, day] = date.split('-').map(Number);
    const next = new Date(Date.UTC(year, month - 1, day));
    if (repeat === 'daily')
        next.setUTCDate(next.getUTCDate() + 1);
    if (repeat === 'weekly')
        next.setUTCDate(next.getUTCDate() + 7);
    if (repeat === 'monthly') {
        // The 31st becomes the last day of a shorter month, not the 1st after it.
        const target = next.getUTCMonth() + 1;
        next.setUTCDate(1);
        next.setUTCMonth(target);
        const lastDay = new Date(Date.UTC(next.getUTCFullYear(), next.getUTCMonth() + 1, 0)).getUTCDate();
        next.setUTCDate(Math.min(day, lastDay));
    }
    return next.toISOString().slice(0, 10);
}
/**
 * The date a repeating item moves to when it's done: one period after its
 * due date, skipping ahead past today if it was overdue (doing Monday's
 * weekly chore on Thursday makes it due next Monday, not this one). With no
 * due date, one period from today.
 */
export function nextDueDate(dueDate, repeat, today = isoToday()) {
    let next = addPeriod(dueDate ?? today, repeat);
    while (next <= today)
        next = addPeriod(next, repeat);
    return next;
}
//# sourceMappingURL=lists.js.map